import React, { useEffect, useRef, useState } from 'react';
import styles from './FadeInComponent.module.scss';
import cx from 'classnames';

const FadeComponent = props => {
  const { onHover, children } = props;

  return (
    <div
      className={cx(styles.fadeComponent, {
        [styles.onHover]: onHover,
      })}
    >
      {children}
    </div>
  );
};

export default FadeComponent;
